import LOOKUP from 'constants/lookup';

// +++++++++++ PATIENT +++++++++++

const navigate = (path) => {
    return window.location = path;
}

export const patientViewCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.user.items.patient.link,
            text: LOOKUP.menu.user.items.patient.text
        }
    ],
    current: LOOKUP.patient.viewTitle,
    redirectTo: () => navigate("/member")
};

export const patientListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.user.items.patient.text,
    redirectTo: null
};

export const patientAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.user.items.patient.link,
            text: LOOKUP.menu.user.items.patient.text
        }
    ],
    current: 'Add New Member', //MOVE TO LOOKUP
    redirectTo: () => navigate("/member")
};

export const patientEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.user.items.patient.link,
            text: LOOKUP.menu.user.items.patient.text
        }
    ],
    current: 'Edit Member',
    redirectTo: () => navigate("/member") //Would be good pass the id of the patient and return to the Patient details if Id is set
}



// +++++++++++ EMPLOYEE +++++++++++

export const employeeListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: 'Employee List',
    redirectTo: null
}

export const employeeViewCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.user.items.employee.link,
            text: LOOKUP.menu.user.items.employee.text
        }
    ],
    current: LOOKUP.employee.viewTitle,
    redirectTo: () => navigate("/employee")
}

export const employeeAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.user.items.employee.link,
            text: LOOKUP.menu.user.items.employee.text
        }
    ],
    current: 'Add New Employee',
    redirectTo: () => navigate("/employee")
};

export const employeeEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.user.items.employee.link,
            text: LOOKUP.menu.user.items.employee.text
        }
    ],
    current: 'Edit Employee',
    redirectTo: () => navigate("/employee") //Would be good pass the id of the employee and return to the employee details if Id is set
};

// +++++++++++ DOCTORS +++++++++++

export const doctorListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.user.items.doctor.text,
    redirectTo: null
}

export const doctorViewCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.user.items.doctor.link,
            text: LOOKUP.menu.user.items.doctor.text
        }
    ],
    current: "Doctor View",
    redirectTo: () => navigate("/doctor")
}

export const doctorEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.user.items.doctor.link,
            text: LOOKUP.menu.user.items.doctor.text
        }
    ],
    current: 'Edit Doctor',
    redirectTo: () => navigate("/doctor")
};

export const doctorAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.user.items.doctor.link,
            text: LOOKUP.menu.user.items.doctor.text
        }
    ],
    current: 'Add New Doctor',
    redirectTo: () => navigate("/doctor")
};

// +++++++++++ VENDORS +++++++++++

export const vendorListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.user.items.vendor.text,
    redirectTo: null
}

export const vendorViewCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.user.items.vendor.link,
            text: LOOKUP.menu.user.items.vendor.text
        }
    ],
    current: "Vendor View",
    redirectTo: () => navigate("/vendor")
}

export const vendorEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.user.items.vendor.link,
            text: LOOKUP.menu.user.items.vendor.text
        }
    ],
    current: 'Edit Vendor',
    redirectTo: () => navigate("/vendor")
};

export const vendorAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.user.items.vendor.link,
            text: LOOKUP.menu.user.items.vendor.text
        }
    ],
    current: "Add New Vendor",
    redirectTo: () => navigate("/vendor")
};

export const vendorCatelogCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.inventory.items.vendorCatelog.text,
    redirectTo: null
}

export const multiStoreCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.inventory.items.multiStoreManagement.text,
    redirectTo: null
}

/// +++++++++ USER ROLE ++++++++++
export const userRoleListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.user.items.userRole.text,
    redirectTo: null
};

export const userRoleAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.user.items.userRole.link,
            text: LOOKUP.menu.user.items.userRole.text
        }
    ],
    current: "Add New User Role",
    redirectTo: () => navigate("/userrole")
};

export const userRoleEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.user.items.userRole.link,
            text: LOOKUP.menu.user.items.userRole.text
        }
    ],
    current: "Edit Role",
    redirectTo: () => navigate("/userrole")
};

//INVENTORY ADJUST


//INVENTORY ADJUST

export const inventoryAdjustCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],

    current: LOOKUP.transferProduct.inventoryAdjust.label,
    redirectTo: null
};

//Bulk transfer
export const bulkTransferCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],

    current: LOOKUP.menu.inventory.items.bulkTransferProduct.text,
    redirectTo: null
};

export const bulkTransferEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.inventory.items.bulkTransferProduct.link,
            text: LOOKUP.menu.inventory.items.bulkTransferProduct.text
        }
    ],

    current: 'Edit Bulk Transfer ',
    redirectTo: () => navigate("/bulktransferproduct")
};

export const bulkTransferAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.inventory.items.bulkTransferProduct.link,
            text: LOOKUP.menu.inventory.items.bulkTransferProduct.text
        }
    ],

    current: 'New Bulk Transfer',
    redirectTo: () => navigate("/bulktransferproduct")
};

export const bulkTransferViewCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.inventory.items.bulkTransferProduct.link,
            text: LOOKUP.menu.inventory.items.bulkTransferProduct.text
        }
    ],

    current: 'View Bulk Transfer ',
    redirectTo: () => navigate("/bulktransferproduct")
};

// +++++++++++ PRODUCT +++++++++++

export const productListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],

    current: 'Product List',
    redirectTo: null
};

export const productViewCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.product.link,
            text: LOOKUP.menu.product.text
        }
    ],
    current: LOOKUP.product.viewTitle,
    redirectTo: () => navigate("/product")
};

export const productAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.product.link,
            text: LOOKUP.menu.product.text
        }
    ],
    current: 'Add New Product',
    redirectTo: () => navigate("/product")
};

export const productEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.product.link,
            text: LOOKUP.menu.product.text
        }
    ],
    current: 'Edit Product',
    redirectTo: () => navigate("/product")
};

// +++++++++++ AUDIT +++++++++++

export const auditListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],

    current: LOOKUP.menu.inventoryaudit.text,
    redirectTo: null
};

export const auditViewCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.inventoryaudit.link,
            text: LOOKUP.menu.inventoryaudit.text
        }
    ],
    current: LOOKUP.inventoryAudit.viewTitle,
    redirectTo: () => navigate("/inventoryaudit")
};

export const auditAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.inventoryaudit.link,
            text: LOOKUP.menu.inventoryaudit.text
        }
    ],
    current: 'Add Inventory Audit',
    redirectTo: () => navigate("/inventoryaudit")
};

// +++++++++++ PURCHASE ORDER +++++++++++

export const poListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],

    current: LOOKUP.menu.inventory.items.purchaseOrder.text,
    redirectTo: null
};

export const poEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.inventory.items.purchaseOrder.link,
            text: LOOKUP.menu.inventory.items.purchaseOrder.text
        }
    ],

    current: 'Edit Purchase Order',
    redirectTo: () => navigate("/purchaseOrder")
};

export const poReportEditCrumb = {
    links: [
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        },
        {
            link: LOOKUP.report.purchaseOrderReport.link,
            text: LOOKUP.report.purchaseOrderReport.text
        }
    ],

    current: 'Edit Purchase Order',
    redirectTo: () => navigate("/purchaseOrder")
};

export const poAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.inventory.items.purchaseOrder.link,
            text: LOOKUP.menu.inventory.items.purchaseOrder.text
        }
    ],

    current: 'Add New Purchase Order',
    redirectTo: () => navigate("/purchaseOrder")
};

export const poReceiveCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.inventory.items.purchaseOrder.link,
            text: LOOKUP.menu.inventory.items.purchaseOrder.text
        }
    ],

    current: 'Receive Products',
    redirectTo: () => navigate("/purchaseOrder")
};


// +++++++++++ PRODUCT CATEGORY +++++++++++

export const categoryListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],

    current: LOOKUP.menu.productCategory.text,
    redirectTo: null
};

export const categoryViewCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.productCategory.link,
            text: LOOKUP.menu.productCategory.text
        }
    ],
    current: 'Product Category View',
    redirectTo: () => navigate("/product/category")
};

export const categoryAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.productCategory.link,
            text: LOOKUP.menu.productCategory.text
        }
    ],
    current: 'Add New Product Category',
    redirectTo: () => navigate("/product/category")
};

export const categoryEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.productCategory.link,
            text: LOOKUP.menu.productCategory.text
        }
    ],
    current: 'Edit Product Category',
    redirectTo: () => navigate("/product/category")
};

// +++++++++++ TRANSFER PRODUCT +++++++++++

export const transferListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.inventory.items.transferProduct.text,
    redirectTo: null
}
/* ++++++++++ BANK DEPOSITS ++++++++ */

export const bankDepositsListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.admin.items.bankdeposits.text,
    redirectTo: null
};
/* ++++++++++ Safe ManageMents ++++++++ */

export const safeManageMentListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.admin.items.safemanagement.text,
    redirectTo: null
};
export const safeManageMentAdjustmentCrumb = {
    links: [

        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.admin.items.safemanagement.link,
            text: LOOKUP.menu.admin.items.safemanagement.text
        }
    ],
    current: "Adjustment Safe Management",
    redirectTo: () => navigate("/admin/safemanagement")
};
/*---------*/
export const bankDepositsEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.admin.items.bankdeposits.link,
            text: LOOKUP.menu.admin.items.bankdeposits.text
        }
    ],
    current: 'Edit Bank Deposit',
    redirectTo: () => navigate("/admin/bankdeposits")
};

export const bankDepositsAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.admin.items.bankdeposits.link,
            text: LOOKUP.menu.admin.items.bankdeposits.text
        }
    ],
    current: "Add New Bank Deposit",
    redirectTo: () => navigate("/bankdeposits")
};

/* ++++++++++ BANK DEPOSITS ++++++++ */

/* ++++++++++ CASH REGISTER ++++++++ */

export const cashRegisterListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.admin.items.cashregister.text,
    redirectTo: null
};

export const cashRegisterViewCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.admin.items.cashregister.link,
            text: LOOKUP.menu.admin.items.cashregister.text
        }
    ],
    current: 'Cash Register View',
    redirectTo: () => navigate("/admin/cashregister")
};

/* ++++++++++ SHIFT ++++++++ */

export const shiftListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.admin.items.shiftList.text,
    redirectTo: null
};

export const shiftAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.admin.items.shiftList.link,
            text: LOOKUP.menu.admin.items.shiftList.text
        }
    ],
    current: 'Add New Shift',
    redirectTo: () => navigate("/admin/shift/list")
};

export const shiftEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.admin.items.shiftList.link,
            text: LOOKUP.menu.admin.items.shiftList.text
        }
    ],
    current: 'Manage Shift',
    redirectTo: () => navigate("/admin/shift/list")
};

// +++++++++++ SCHEDULE +++++++++++

export const scheduleListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.admin.items.schedule.text,
    redirectTo: null
}

export const scheduleAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.admin.items.schedule.link,
            text: LOOKUP.menu.admin.items.schedule.text
        }
    ],
    current: LOOKUP.menu.admin.items.scheduleAdd.text,
    redirectTo: () => navigate("/admin/schedule")
};

/* ++++++++++ ORDERS ++++++++ */

export const ordersListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.admin.orders.text,
    redirectTo: null
};

export const ordersViewCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.admin.orders.link,
            text: LOOKUP.menu.admin.orders.text
        }
    ],
    current: 'Order Details',
    redirectTo: () => navigate("/admin/orders")
};

/* ++++++++++ SETTINGS ++++++++ */

export const settingsCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.admin.setting.text,
    redirectTo: null
};

export const uiSettingsCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.admin.UIsetting.text,
    redirectTo: null
};

export const seoSettingsCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.admin.SEOSetting.text,
    redirectTo: null
};

/* ++++++++++ MARKETING ++++++++ */

export const communicatingCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.admin.communicating.text,
    redirectTo: null
};

/* ++++++++++ DEVICE ++++++++ */

export const deviceListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.manage.items.device.text,
    redirectTo: null
};

export const deviceEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.manage.items.device.link,
            text: LOOKUP.menu.manage.items.device.text
        }
    ],
    current: 'Edit Device',
    redirectTo: () => navigate("/manage/device")
};

export const deviceAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.manage.items.device.link,
            text: LOOKUP.menu.manage.items.device.text
        }
    ],
    current: 'Add Device',
    redirectTo: () => navigate("/manage/device")
};

/* ++++++++++ PAYMENT ++++++++ */

export const paymentListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.manage.items.payment.text,
    redirectTo: null
};

export const paymentEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.manage.items.payment.link,
            text: LOOKUP.menu.manage.items.payment.text
        }
    ],
    current: 'Edit Payment',
    redirectTo: () => navigate("/manage/payment")
};

export const paymentAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.manage.items.payment.link,
            text: LOOKUP.menu.manage.items.payment.text
        }
    ],
    current: 'Add Payment',
    redirectTo: () => navigate("/manage/payment")
};

/* ++++++++++ TAX RATES ++++++++ */

export const taxListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.manage.items.taxrate.text,
    redirectTo: null
};

export const taxEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.manage.items.taxrate.link,
            text: LOOKUP.menu.manage.items.taxrate.text
        }
    ],
    current: 'Edit Tax Rates',
    redirectTo: () => navigate("/manage/taxrate")
};

export const taxAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.manage.items.taxrate.link,
            text: LOOKUP.menu.manage.items.taxrate.text
        }
    ],
    current: 'Add Tax Rates',
    redirectTo: () => navigate("/manage/taxrate")
};

/* ++++++++++ MEASUREMENT SETTINGS ++++++++ */

export const measurementListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.manage.items.weight.text,
    redirectTo: null
};

export const measurementEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.manage.items.weight.link,
            text: LOOKUP.menu.manage.items.weight.text
        }
    ],
    current: 'Edit Settings',
    redirectTo: () => navigate("/manage/measurement")
};

export const measurementAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.manage.items.weight.link,
            text: LOOKUP.menu.manage.items.weight.text
        }
    ],
    current: 'Add New Settings',
    redirectTo: () => navigate("/manage/measurement")
};

/* ++++++++++ PRICE SETTINGS ++++++++ */

export const priceMatrixListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.inventory.items.priceMatrix.text,
    redirectTo: null
};

export const priceMatrixEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.inventory.items.priceMatrix.link,
            text: LOOKUP.menu.inventory.items.priceMatrix.text
        }
    ],
    current: 'Manage Price Matrix',
    redirectTo: () => navigate("/manage/measurement")
};

/* ++++++++++ CAMPAING SETTINGS ++++++++ */

export const campaignListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.manage.items.campaign.text,
    redirectTo: null
};

export const campaignEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.manage.items.campaign.link,
            text: LOOKUP.menu.manage.items.campaign.text
        }
    ],
    current: 'Manage Campaigns',
    redirectTo: () => navigate("/manage/campaign")
};

/* ++++++++++ COMBO SETTINGS ++++++++ */

export const comboListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.manage.items.combo.text,
    redirectTo: null
};

export const comboEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.manage.items.combo.link,
            text: LOOKUP.menu.manage.items.combo.text
        }
    ],
    current: 'Manage Combos',
    redirectTo: () => navigate("/manage/combo")
};

/* ++++++++++ DISCOUNT SETTINGS ++++++++ */

export const discountListCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.manage.items.discount.text,
    redirectTo: null
};

export const discountEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.menu.manage.items.discount.link,
            text: LOOKUP.menu.manage.items.discount.text
        }
    ],
    current: 'Manage Discounts',
    redirectTo: () => navigate("/manage/discount")
};

/* ++++++++++ VIDEO SUPPORT ++++++++ */

export const videoSupportCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.support.videoSupport.title,
    redirectTo: null
};

/* ++++++++++ REPORT ++++++++ */

export const reportCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.report.text,
    redirectTo: null
};

export const reportMemberDemograpic = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.membersDemographics.text,
    redirectTo: () => navigate("/report")
};

export const reportInventoryCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.inventoryLevel.text,
    redirectTo: () => navigate("/report")
};

export const reportAggregateInventoryLevel = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: 'Aggreagte Inventory Level',
    redirectTo: () => navigate("/report")
};
export const reportInventorySnapShot = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.inventorySnapShot.text,
    redirectTo: () => navigate("/report")
};

export const reportMonthlyInventory = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.MonthlyInventory.text,
    redirectTo: () => navigate("/report")
};

export const reportwarehouseTransfer = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.warehouseTransfer.text,
    redirectTo: () => navigate("/report")
};

export const reportInventoryAge = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.inventoryAge.text,
    redirectTo: () => navigate("/report")
}

export const reportRestockbyCaps = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.restockbyCaps.text,
    redirectTo: () => navigate("/report")
}

export const reportReorderReport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.reorderReport.text,
    redirectTo: () => navigate("/report")
};

export const reportDailySalesReport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.dailySalesReport.text,
    redirectTo: () => navigate("/report")
};
export const reportPurchaseOrderReceiver = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.purchaseOrderReceiver.text,
    redirectTo: () => navigate("/report")
};

export const reportAggregateSales = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.aggregateSales.text,
    redirectTo: () => navigate("/report")
};

export const reportAggregateInventory = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.aggregateInventory.text,
    redirectTo: () => navigate("/report")
};

export const reportMonthlySalesReport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.monthlySalesReport.text,
    redirectTo: () => navigate("/report")
};

export const reportDailyProfitReport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.dailyProfitReport.text,
    redirectTo: () => navigate("/report")
};

export const reportMonthlyProfitReport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.monthlyProfitReport.text,
    redirectTo: () => navigate("/report")
};

export const reportYearlySalesReport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.yearlySalesReport.text,
    redirectTo: () => navigate("/report")
};

export const reportYearlyProfitReport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.yearlyProfitReport.text,
    redirectTo: () => navigate("/report")
};

export const reportgmroireport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.gmroiReport.text,
    redirectTo: () => navigate("/report")
};

export const reportSellThroughReport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.sellThrough.text,
    redirectTo: () => navigate("/report")
};

export const reportTaxCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.taxSummary.text,
    redirectTo: () => navigate("/report")
};

export const reportpurchaseorderreport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.purchaseOrderReport.text,
    redirectTo: () => navigate("/report")
};

export const reportGeneralReport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.generalReport.text,
    redirectTo: () => navigate("/report")
};

export const reportHourlySalesReport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.hourlySales.text,
    redirectTo: () => navigate("/report")
};

export const reportEndOfDayReport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.endOfDay.text,
    redirectTo: () => navigate("/report")
};

export const reportDailyCashCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.dailyCashSummary.text,
    redirectTo: () => navigate("/report")
};

export const reportSalesByTypeCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.salesBytype.text,
    redirectTo: () => navigate("/report")
};

export const reportTransactionSalesSummaryCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.transactionSummary.text,
    redirectTo: () => navigate("/report")
};

export const reportCustomerSalesCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.customerSales.text,
    redirectTo: () => navigate("/report")
};

export const reportProfitReportCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.profitReport.text,
    redirectTo: () => navigate("/report")
};

export const reportCombinedSales = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.combinedSalesReport.text,
    redirectTo: () => navigate("/report")
};

export const reportAggregateBranchesCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.aggregateBranches.text,
    redirectTo: () => navigate("/report")
};

export const reportDiscountReport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.discountReport.text,
    redirectTo: () => navigate("/report")
};

export const reportCategorySales = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.categorysales.text,
    redirectTo: () => navigate("/report")
};

export const reportBudgetPlanner = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.budgetPlannerReport.text,
    redirectTo: () => navigate("/report")
};

export const reportCreditPaymentsCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.creditPayments.text,
    redirectTo: () => navigate("/report")
};

export const reportGiftCardRBalanceCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.giftCardBalance.text,
    redirectTo: () => navigate("/report")
};

export const reportManualInventoryChangeReport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.manualInventoryChange.text,
    redirectTo: () => navigate("/report")
};

export const reportDestroyedProductReport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.destroyedProductReport.text,
    redirectTo: () => navigate("/report")
};

export const reportDiscrepancyReport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.discrepancyReport.text,
    redirectTo: () => navigate("/report")
};

export const reportRevenueReportCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.revenueReport.text,
    redirectTo: () => navigate("/report")
};

export const reportProductSalesCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.productSales.text,
    redirectTo: () => navigate("/report")
};

export const productRankingCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.productRakingReport.text,
    redirectTo: () => navigate("/report")
};

export const reportBudtenderSalesCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.budtenderAvgSales.text,
    redirectTo: () => navigate("/report")
};

export const reportAnnualSalesCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.annualSales.text,
    redirectTo: () => navigate("/report")
};

export const reportShoppingTrend = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.shoppingTrend.text,
    redirectTo: () => navigate("/report")
};

export const reportSalesCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.salesSummary.text,
    redirectTo: () => navigate("/report")
};

export const reportTransactionCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.transactionDetails.text,
    redirectTo: () => navigate("/report")
};

export const reportMonthlyProductSalesCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.monthlyProductSales.text,
    redirectTo: () => navigate("/report")
};

export const reportEmployeeHoursCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.employeeHours.text,
    redirectTo: () => navigate("/report")
};

export const reportEmployeeTimesheetCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.employeeTimesheet.text,
    redirectTo: () => navigate("/report")
};

export const reportBrandSalesReportCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.brandSales.text,
    redirectTo: () => navigate("/report")
};

export const reportOnlineInstoreReportCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.onlineInstore.text,
    redirectTo: () => navigate("/report")
};

export const reportCategoryProduct = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.productbycategory.text,
    redirectTo: () => navigate("/report")
};

export const reportIRCC = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],

    current: LOOKUP.report.irccReport.text,
    redirectTo: () => navigate("/report")
};

export const reportProductPriceChangeReportCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.productPriceChangeReport.text,
    redirectTo: () => navigate("/report")
};

export const reportDeliveryReportCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.deliveryReport.text,
    redirectTo: () => navigate("/report")
};

export const reportGiftCardReportCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.giftCardReport.text,
    redirectTo: () => navigate("/report")
};

export const ReportInventoryMovementCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.InventoryMovement.text,
    redirectTo: () => navigate("/report")
};

export const ReportInventoryLogCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.InventoryLog.text,
    redirectTo: () => navigate("/report")
};

export const reportSalesSummaryDetailCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.SalesSummaryDetails.text,
    redirectTo: () => navigate("/report")
};

export const reportAggregateBranchSalesInventoryCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.AggregateBranchSalesInventory.text,
    redirectTo: () => navigate("/report")
};

export const reportAuditReport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.AuditReport.text,
    redirectTo: () => navigate("/report")
};

export const reportFiskalyCashPointClosingReport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.FiskalyCashPointClosingReport.text,
    redirectTo: () => navigate("/report")
};


export const reportUncountedReport = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.UncountedReport.text,
    redirectTo: () => navigate("/report")
};

export const reportHightideReportsCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.report.link,
            text: LOOKUP.report.text
        }
    ],
    current: LOOKUP.report.HightideReports.text,
    redirectTo: () => navigate("/report")
};

/* ++++++++++ WEB MENU ++++++++ */

export const webMenuCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.ecommerce.menu.menuList.title,
    redirectTo: null
};

export const carouselCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.ecommerce.carousel.carouselList.title,
    redirectTo: null
};

export const storeRulesCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.ecommerce.storeRules.storeRuleslList.title,
    redirectTo: null
};

export const webMenuEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.ecommerce.menu.menuList.link,
            text: LOOKUP.ecommerce.menu.menuList.title
        }
    ],
    current: 'Edit Menu',
    redirectTo: () => navigate("/ecommerce/menu")
};

export const webMenuAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.ecommerce.menu.menuList.link,
            text: LOOKUP.ecommerce.menu.menuList.title
        }
    ],
    current: 'Add New Menu',
    redirectTo: () => navigate("/ecommerce/menu")
};

export const carouselEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.ecommerce.carousel.carouselList.link,
            text: LOOKUP.ecommerce.carousel.carouselList.title
        }
    ],
    current: 'Edit Carousel',
    redirectTo: () => navigate("/ecommerce/carousel")
};

export const carouselAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.ecommerce.carousel.carouselList.link,
            text: LOOKUP.ecommerce.carousel.carouselList.title
        }
    ],
    current: 'Add New Carousel',
    redirectTo: () => navigate("/ecommerce/carousel")
};

export const storeRulesEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.ecommerce.storeRules.storeRuleslList.link,
            text: LOOKUP.ecommerce.storeRules.storeRuleslList.title
        }
    ],
    current: 'Edit Store Rules',
    redirectTo: () => navigate("/ecommerce/storerules")
};

export const storeRulesAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.ecommerce.storeRules.storeRuleslList.link,
            text: LOOKUP.ecommerce.storeRules.storeRuleslList.title
        }
    ],
    current: 'Add New Store Rules',
    redirectTo: () => navigate("/ecommerce/storerules")
};

/* ++++++++++ HOME SETTINGS ++++++++ */

export const homeSettingsCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.ecommerce.homeSetting.title,
    redirectTo: null
};

/* ++++++++++ ONLINE ORDERS ++++++++ */

export const onlineOrdersCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }

    ],
    current: LOOKUP.ecommerce.onlineOrders.title,
    redirectTo: null
}

export const onlineOrdersDetailCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.ecommerce.onlineOrders.order.orderList.link,
            text: LOOKUP.ecommerce.onlineOrders.order.orderList.title
        }
    ],
    current: "Online Order View",
    redirectTo: null
}

// export const onlineOrdersEditCrumb = {
//     links: [
//         {
//             link: LOOKUP.menu.home.link,
//             text: LOOKUP.menu.home.text
//         },
//         // {
//         //     link: LOOKUP.ecommerce.order.orderList.link,
//         //     text: LOOKUP.ecommerce.order.orderList.text
//         // }
//     ],
//     current: 'Edit Online Order',
//     redirectTo: () => navigate("ecommerce/online-orders")
// }

export const integrationCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: "Integration Overview",
    redirectTo: null
}

/* ++++++++++ COMPLIANCE REPORT ++++++++ */

export const compliancesCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: "Compliance Report",
    redirectTo: null
};


/************BULK PRICE UPDATE */

export const bulkPriceCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        }
    ],
    current: LOOKUP.menu.manage.items.priceupdate.text,
    redirectTo: null
};

/************BANNER Edit */

export const bannerEditCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.ecommerce.BannerList.BannerListPage.link,
            text: LOOKUP.ecommerce.BannerList.BannerListPage.title
        }
    ],
    current: 'Edit Banner',
    redirectTo: () => navigate("/ecommerce/bannerList")
};

export const bannerAddCrumb = {
    links: [
        {
            link: LOOKUP.menu.home.link,
            text: LOOKUP.menu.home.text
        },
        {
            link: LOOKUP.ecommerce.BannerList.BannerListPage.link,
            text: LOOKUP.ecommerce.BannerList.BannerListPage.title
        }
    ],
    current: 'Add New Banner',
    redirectTo: () => navigate("/ecommerce/bannerList")
};